import O from "./O";
import { useSelector, useStore } from 'react-redux'
import { useContext } from 'react';
import G from './Getters';
import imageMap from './imageMap';
import { useRef } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import computeFilters from './computeFilters';
import { TemporaryAdjustmentsContext } from './Contexts';

export default function ImagePreview({
  onClick,
  imageId, 
  filters,
  filterId,
}){

  /*
  const store = useStore();
  const state = store.getState();
  const image = G.getImage(state,imageId);
  let { height, adjustments } = image;
  */


  if( !imageId ){
    debugger;
  }
  const { temporaryAdjustments } = useContext(TemporaryAdjustmentsContext) ?? {};

  const store = useStore();
  const state = store.getState();

  let fallBackOnRaw;

  if( process.env.NODE_ENV === "development" ){
    fallBackOnRaw = true;
  }


  const image = G.getImage(state,imageId);
  let src = imageMap[imageId] || G.getImageRecordUrl(state,{
    imageId,fallBackOnRaw
  }) 
  let { adjustments, height } = image;
  

  


  //let resolvedSource = imageMap[src]||src;

  let resolvedSource = imageMap[src]||imageMap[imageId]||src;

  /*if( imageId.includes('tif') || imageId.includes('png') ){
    resolvedSource = ("/images/"+imageId.replace("tif","jpeg"));
  }*/

 
  const imgContainerRef = useRef();


  let imageDim = {};
  if( height > 1 ){
    imageDim.height = '100%';
  }else{
    imageDim.width = '100%';
    imageDim.maxHeight = '100%';
  }

  let imageStyle ={
        objectFit:'contain',
      ...imageDim,
      ...(computeFilters({...adjustments,...temporaryAdjustments})),
      
      } 

  if( filterId ){
    imageStyle.filter = `url(#${filterId})`;
  }


  return (
    <div class="full-height full-width rel imageUpload-preview" imageId={imageId} onClick={onClick} style={{ 
      //aspectRatio:'1 / 1',
      //overflow:'scroll',
      //border:'3px solid magenta',
      //padding:5, 
      }}>
      <Tooltip title={imageId}>
      <img style={imageStyle} src={resolvedSource||"ISSUE_WITH_THE_SOURCE"}/>
      </Tooltip>
    </div>
  )
}


